<template>
    <div class="api-detail">
        <el-table :data="detailData" stripe
        style="width: 100%;"
        height="200">
            <el-table-column prop="createtime" label="订单时间" fixed></el-table-column>
            <el-table-column v-for="(col, index) in columnName" :key="'col_'+index"
            :prop="col.key" :label="col.name"></el-table-column>
        </el-table>
        <TurnPage @turnPage="turnPageEvent"></TurnPage>
    </div>
</template>


<script>
import TurnPage from "@/components/unilateral/Unilateral-turn.vue";
import { getUTaskDetail } from "@/api/api";
import { mapState } from "vuex";

export default {
    components: {
        TurnPage
    },
    data: function () {
        return {
            taskId: "",
            recordId: '',
            detailData: [],
            columnName: [
                // {name: "ID", key: "id"},
                // {name: "订单时间", key: "createtime", 'fixed': 'fixed'},
                {name: "策略名称", key: "strategy_name"},
                {name: "币种", key: "instrument_id"},
                {name: "订单号", key: "order_id"},
                {name: "交易平台", key: "bourse"},
                {name: "委托数量", key: "size"},
                {name: "交易数量", key: "filled_qty"},
                {name: "委托价格", key: "price"},
                {name: "成交均价", key: "price_avg"},
                {name: "交易类型", key: "type"},
                {name: "订单状态", key: "state"},
            ],
            pageNum: 20,
            pageObj: 1,
            isAddPages: true,
        }
    },
    props: {
        apiId: Number
    },
    watch: {
        apiId(e) {
            if (e !== 0) {
                this.taskId = e;
                this.isAddPages = false;
                this.recordId = '';
                this.pageNum = 20;
                if (typeof this.pageObj == 'object') {
                    this.pageObj.pages = 1;
                    this.pageObj = 1;
                }
                this.getTaskData();
            }
        }
    },
    computed: {
        ...mapState([
            "token"
        ])
    },
    methods: {
        // 获取任务交易数据
        getTaskData() {
            var param = {
                token: this.token,
                api_ids: this.taskId,
                recordId: this.recordId,
                number: this.pageNum
            };
            getUTaskDetail(param).then(res => {
                if (res.code === 200) {
                    this.detailData = res.data;
                    if (this.detailData.length !== 0 && this.isAddPages) {
                        if (this.pageObj.direction == 'next') {
                            this.pageObj.pages ++;
                        } else if (this.pageObj.direction == 'last') {
                            this.pageObj.pages --;
                        }
                    } 
                } else {
                   this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 200
                    }) 
                }
            })
        },

        // 翻页触发事件
        turnPageEvent(flag, ctx) {
            this.pageObj = ctx;
            this.isAddPages = true;
            if (flag == 'next') {
                if (this.detailData.length !== 0) {
                    this.recordId = this.detailData.slice(-1)[0].id;
                } 
                this.pageNum = 20;
            } else if (flag == 'last') {
                if (this.detailData.length !== 0) {
                    this.recordId = this.detailData[0].id;
                }
                this.pageNum = -20;
            }
            this.getTaskData();
        },
        update(id) {
            this.taskId = id;
            this.getTaskData();
        }
    }
}
</script>

<style lang="scss">
.api-detail {
    .el-table{
        font-size: 12px;
    }
    .el-table th, .el-table tr{
        background-color: #2a2d2e;
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td {
        background-color: #262829;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
        background-color: #262829;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #262829;
    }
    .el-table__body tr.hover-row>td {
        background-color: #262829 !important;
        color: #888a8e;
    }
    .el-table, .el-table__expanded-cell{
        background-color: transparent;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before{
        background-color: transparent;
    }
    .el-table__fixed-right::before, .el-table__fixed::before{
        background-color: transparent;
    }
}
</style>
